import type { HelpFile } from '../../types/help'
import { AccessProfileCreateTestIds } from '../../../testids/AccessProfileCreateTestIds'

export const accessProfileCreateHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfileCreateTestIds.accessProfileCreatePage]:
      'Neues Zugriffsprofil anlegen — Name, Code, Risikostufe und die Enforcement-Objekte, die es auf Zielsystemen gewährt.',
  },
}
